module.exports = __webpack_public_path__ + "media/images/icons/filled/database-3bcd426403ed5fc9962b8c6ed51d7807.svg";